module.exports = __webpack_public_path__ + "img/home.40871de0.jpg";